export default function (initialDataInteractor, questionnaireId, questionPosition) {
  initialDataInteractor.data.questionnaires.find(function (questionnaire) {
    return questionnaire.id == questionnaireId;
  }).questions.splice(questionPosition, 1);
}